



import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import CostRevenueChart from "../components/Charts/CostRevenueChart";
import JobPerformance from "../components/Charts/JobPerformance";
import { pageRoutes } from "../routes/PageRoutes";
import { useNavigate } from "react-router-dom";

const CustomerRequests = () => {
      const navigate = useNavigate();
  const [isToggle, setIsToggle] = useState(false);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="customer-requests" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
       <div className="d-flex justify-content-end align-items-center ct_flex_wrap_767 gap-md-5 gap-4 ct_mb_32 w-100">
                <div className="search-box ">
                  <div className="input-group position-relative">
                    <input
                      className="form-control ct_input ct_input_ps_40 ct_transparent_input"
                      type="text"
                 
                    
                      placeholder="Search by name, owner"
                    />
                    <i className="fas fa-search ct_show_search"></i>
                  </div>
                </div>

                {/*  */}
                <div className="d-flex ct_w_100_767 ct_flex_col_575 gap-4">
                 <div className="dropdown ct_w_100_767 d-flex     " >
      <button
        style={{ backgroundColor: "#fff" }}
        className="btn filter-dropdown flex-grow-1 ct_w_100_575 d-flex align-items-center gap-4 justify-content-between text-nowrap"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        All Status
       
        <i className="fa-solid fa-angle-down"></i>
      </button>

      <ul className="dropdown-menu ct_custom_dropdown_filter">
       
          <li
          
            className="ct_pointer"
            
          >
            <a className="dropdown-item">Quote Sent</a>
          </li>
             <li
          
            className="ct_pointer"
            
          >
            <a className="dropdown-item">In Review</a>
          </li>
             <li
          
            className="ct_pointer"
            
          >
            <a className="dropdown-item"> Rejected</a>
          </li>
       
      </ul>
    </div>
               
                  <div className="ct_w_100_767">
                    <a
                      className="ct_orange_btn ct_grey_btn ct_w_100_575 flex-grow-1 service_presets_btn px-3"
                      onClick={() => {
                        navigate(pageRoutes?.quotes);
                      }}
                    >
                    <svg className="me-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 19H13V18H15V13H11V12H15V10H13V9H11V10H9V15H13V16H9V18H11V19ZM4 22V2H15L20 7V22H4ZM6 20H18V8H14V4H6V20Z" fill="white"/>
</svg>

                      Quote Sent
                    </a>
                  </div>
                </div>
              </div>




<div class="ct_white_bg p-4 ct_border_radius_12 ct_mt_30">
   <div class="custom_table_wrapper">
      <div class="table-responsive  ct_custom_table">
         <table class="table">
            <thead>
               <tr>
                  <th>S.No.</th>
               
                  <th> Request ID</th>
                  <th>Customer</th>
                  <th>Boat Name  </th>
                
                  <th> Service Type</th>
                  <th>Date Sent</th>
                  <th>Status</th>
                  <th>Action</th>
               </tr>
            </thead>
          
            <tbody>
             
               <tr>
                  <td className="ct_text_para">1</td>
                 
                  <td
                  className="ct_text_para"
                  
                  >
                 REQ-1023
                  </td>
                
                  <td className="ct_text_para">
                   John Smith
                  </td>
              
                  <td className="ct_text_para"
                  >
                  Sea Voyager II
                  </td>
                <td className="ct_text_para">Engine Repair</td>
                <td className="ct_text_para">
                  25/09/2025
                </td>
                 <td>
                      <div className="d-flex align-items-center gap-3">
                     
                      <span class="active-dot"></span>
                    

                        <span class="ct_active_badge">
                         Quote Sent
                        </span>
                      </div>
                    </td>
                
                  <td className="">
                    
                    
                    
                     
                        <a
                        href="javascript:void(0)"
                      
                        onClick={() => {
                        navigate(pageRoutes?.CustomerRequestDetail, {
                       
                        });
                        }}
                     
                        >
                        <svg
                           width={22}
                           height={15}
                           viewBox="0 0 22 15"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                           >
                           <path
                              d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
                              stroke="#23C0E8"
                              strokeWidth="1.57885"
                              strokeLinejoin="round"
                              />
                           <path
                              d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
                              stroke="#23C0E8"
                              strokeWidth="1.57885"
                              strokeLinejoin="round"
                              />
                        </svg>
                        </a>
                     
                  </td>
               </tr>
                  <tr>
                  <td className="ct_text_para">1</td>
                 
                  <td
                  className="ct_text_para"
                  
                  >
                 REQ-1023
                  </td>
                
                  <td className="ct_text_para">
                   John Smith
                  </td>
              
                  <td className="ct_text_para"
                  >
                  Sea Voyager II
                  </td>
                <td className="ct_text_para">Engine Repair</td>
                <td className="ct_text_para">
                  25/09/2025
                </td>
                 <td>
                      <div className="d-flex align-items-center gap-3">
                     
                      <span class="pending-dot"></span>
                    

                        <span class="ct_pending_badge">
                         In Review
                        </span>
                      </div>
                    </td>
                
                  <td className="">
                    
                    
                    
                     
                        <a
                        href="javascript:void(0)"
                      
                        onClick={() => {
                        navigate(pageRoutes?.CustomerRequestDetail, {
                       
                        });
                        }}
                     
                        >
                        <svg
                           width={22}
                           height={15}
                           viewBox="0 0 22 15"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                           >
                           <path
                              d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
                              stroke="#23C0E8"
                              strokeWidth="1.57885"
                              strokeLinejoin="round"
                              />
                           <path
                              d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
                              stroke="#23C0E8"
                              strokeWidth="1.57885"
                              strokeLinejoin="round"
                              />
                        </svg>
                        </a>
                     
                  </td>
               </tr>
              <tr>
                  <td className="ct_text_para">1</td>
                 
                  <td
                  className="ct_text_para"
                  
                  >
                 REQ-1023
                  </td>
                
                  <td className="ct_text_para">
                   John Smith
                  </td>
              
                  <td className="ct_text_para"
                  >
                  Sea Voyager II
                  </td>
                <td className="ct_text_para">Engine Repair</td>
                <td className="ct_text_para">
                  25/09/2025
                </td>
                 <td>
                      <div className="d-flex align-items-center gap-3">
                     
                      <span class="inactive-dot"></span>
                    

                        <span class="ct_inactive_badge">
                          Rejected
                        </span>
                      </div>
                    </td>
                
                  <td className="">
                    
                    
                    
                     
                        <a
                        href="javascript:void(0)"
                      
                        onClick={() => {
                        navigate(pageRoutes?.CustomerRequestDetail, {
                       
                        });
                        }}
                     
                        >
                        <svg
                           width={22}
                           height={15}
                           viewBox="0 0 22 15"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                           >
                           <path
                              d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
                              stroke="#23C0E8"
                              strokeWidth="1.57885"
                              strokeLinejoin="round"
                              />
                           <path
                              d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
                              stroke="#23C0E8"
                              strokeWidth="1.57885"
                              strokeLinejoin="round"
                              />
                        </svg>
                        </a>
                     
                  </td>
               </tr>
            </tbody>
        
         </table>
      </div>
   </div>
</div>
          
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerRequests;

